import { checkAuth } from '@/router/helpers.js';

const PickTheFate = () => /* webpackChunkName: "group-pick-the-fate" */ import('@/views/Events/PickTheFate/Home.vue');
const Home = () => /* webpackChunkName: "group-pick-the-fate" */ import('@/views/Events/PickTheFate/Season.vue');
const Case = () => /* webpackChunkName: "group-pick-the-fate" */ import('@/views/Events/PickTheFate/CaseList.vue');
// const CaseDetail = () =>
//   /* webpackChunkName: "group-pick-the-fate" */ import('@/views/Events/PickTheFate/CaseDetail.vue');
const Guide = () => /* webpackChunkName: "group-pick-the-fate" */ import('@/views/Events/PickTheFate/Guide.vue');

export const pickTheFate = [
  {
    path: '/pick-the-fate',
    redirect: '/pick-the-fate/home',
    component: PickTheFate,
    beforeEnter: checkAuth(),
    children: [
      {
        path: 'home',
        name: 'PickTheFateHome',
        component: Home,
      },
      {
        path: 'case',
        name: 'PickTheFateCase',
        component: Case,
      },
      // {
      //   path: 'case/detail/:id',
      //   name: 'PickTheFateCaseDetail',
      //   component: CaseDetail,
      // },
      {
        path: 'guide',
        name: 'PickTheFateGuide',
        component: Guide,
      },
    ],
  },
];
